import dayjs from 'dayjs';

/**
 *  Returns a Date Object with the same date of the string provided
 *
 * @param dateStr {String} date string get by the record
 */
export const getDateWithoutTZ = (dateStr: string) => {
    const localizedDate = new Date(dateStr);
    const offset = localizedDate.getTimezoneOffset() > 0 ? localizedDate.getTimezoneOffset() : localizedDate.getTimezoneOffset() * -1;
    const dateOnly = new Date(localizedDate.valueOf() + offset * 60 * 1000);
    return dateOnly;
};

/**
 * Returns a formatted string representing the date and time in UTC relative to the current time.
 *
 * @param {string} value - The date string to be formatted.
 * @return {string} The formatted date and time string in the format "ddd, DD MMM YYYY HH:mm:ss".
 */
export const getRelativeDateTimeUTCFormat = (value: string) =>
    dayjs(new Date(value as string).toUTCString()).format('ddd, DD MMM YYYY HH:mm:ss');
